import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import '../Customers/CustomersStyle.css';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import RichTextEditor from 'react-rte';
import FormatEmail from '../Common/EmailService';

const EmailSettingsData = {
    SMTP: "",
    PORT: 0,
    Login: "",
    Password: "",
    From: "",
    Subject: "",
    Template: ""
}

const EmailSettings = () => {

    const { CurrentTheme } = useContext(ThemeContext);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [EmailSettings, setEmailSettings] = useState(EmailSettingsData);
    const [StateValue, setStateValue] = useState({ value: RichTextEditor.createEmptyValue() });

    useEffect(() => {
        FetchEmailSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = (value) => {
        setStateValue({ value });
        setEmailSettings({ ...EmailSettings, "Template": value.toString('html') });
    };

    const FetchEmailSettings = () => {
        var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
        setCompanyInfo(companyDetails);

        Axiosfetch(baseURL + "GetEmailSettings", "GET", null, getEmailSettingsSuccess, Failure);
    };

    const getEmailSettingsSuccess = (data) => {
        if (data.length > 0) {
            setEmailSettings(data[0]);
            var value = RichTextEditor.createValueFromString(data[0].Template, 'html');
            setStateValue({ value });
        }
    };

    const onTextChange = (e) => {
        setEmailSettings({ ...EmailSettings, [e.target.name]: e.target.value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseInt(e.target.value);
        setEmailSettings({ ...EmailSettings, [e.target.name]: value });
    };

    const SaveEmailSettingsDetails = (emailData) => {
        Axiosfetch(baseURL + "EditEmailSettings", "POST", emailData, emailDataEditSuccess, Failure);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const emailDataEditSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    };

    const ValidateEmailSettings = (emailsettings) => {
        var errorMsg = "";
        if (emailsettings === null) {
            errorMsg = "Application Error. Please try again"
        }
        else if (emailsettings.SMTP === "") {
            errorMsg = "Enter Valid SMTP Address";
        }
        else if (emailsettings.PORT === "") {
            errorMsg = "Enter Valid PORT Number";
        }
        else if (emailsettings.Login === "") {
            errorMsg = "Enter Valid Login";
        }
        else if (emailsettings.Password === "") {
            errorMsg = "Enter Valid Password";
        }
        else if (emailsettings.From === "") {
            errorMsg = "Enter Valid From Address";
        }
        else if (emailsettings.Subject === "") {
            errorMsg = "Enter Valid Suject";
        }
        else if (emailsettings.Template.trim() === "" || emailsettings.Template.trim() === "<p><br></p>") {
            errorMsg = "Enter Valid Template";
        }

        if (errorMsg !== "") {
            Alert.error(errorMsg, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            return false;
        }

        return true;
    };

    const SendTestEmail = () => {
        var EmailData = EmailSettings;
        if (ValidateEmailSettings(EmailData)) {
            var FormattedEmail = FormatEmail(EmailData, "pankajgandhi1010@gmail.com", "1", companyInfo.Name, 100);
            Axiosfetch(baseURL + "SendEmail", "POST", FormattedEmail, emailDataEditSuccess, Failure);
        }
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show" style={{ padding: "15px" }}>
                <div className="row" style={{
                    height: "80vh", overflow: "auto",
                    scrollbarColor: "#005582 transparent"
                }}>
                    <div className="col-md-12 col-sm-12 align-center">
                        <h5 style={{ fontWeight: "500" }}>Email Settings</h5>
                    </div>
                    <div className="offset-md-1 col-md-10 col-sm-10">
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td style={{ width: "200px" }}>
                                        <h5>SMTP Server<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input className="form-control" name="SMTP"
                                            value={EmailSettings.SMTP}
                                            type="text" onChange={(e) => onTextChange(e)}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>PORT<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>

                                        <input type="number" name="PORT" className="form-control"
                                            value={EmailSettings.PORT} onChange={(e) => onNumberChange(e)} min="0"></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Login<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input className="form-control" name="Login"
                                            value={EmailSettings.Login}
                                            type="text" onChange={(e) => onTextChange(e)}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Password<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input className="form-control" name="Password"
                                            value={EmailSettings.Password}
                                            type="password" onChange={(e) => onTextChange(e)}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>From<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input className="form-control" name="From"
                                            value={EmailSettings.From}
                                            type="text" onChange={(e) => onTextChange(e)}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Subject<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <input className="form-control" name="Subject"
                                            value={EmailSettings.Subject}
                                            type="text" onChange={(e) => onTextChange(e)}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td><h5>Template</h5></td>
                                    <td>
                                        <RichTextEditor value={StateValue.value}
                                            onChange={onChange}></RichTextEditor>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" style={{ textAlign: "right" }}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={() => SaveEmailSettingsDetails(EmailSettings)}>Save</button>
                                                <button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SendTestEmail}>Test Email</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default EmailSettings;